import { render, staticRenderFns } from "./ReportViewer.vue?vue&type=template&id=19f58bf0&scoped=true&"
import script from "./ReportViewer.vue?vue&type=script&lang=ts&"
export * from "./ReportViewer.vue?vue&type=script&lang=ts&"
import style0 from "./ReportViewer.vue?vue&type=style&index=0&id=19f58bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f58bf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSheet,VTooltip})
